import CloudSiteTabs from './cloud-site-tabs';
export default CloudSiteTabs;
